/**
 * Format axios error for user-visible messages (401 / 403 / 422 / validation).
 * @param {unknown} error
 * @returns {string}
 */
function formatValidationFragments(data) {
  const parts = [];
  if (!data || typeof data !== "object") return parts;

  const mapItem = (e) => {
    if (typeof e === "string") return e;
    if (e == null) return "";
    if (e?.field != null && e?.reason != null) {
      return `${e.field}: ${e.reason}`;
    }
    if (e?.msg != null && (e?.path != null || e?.param != null)) {
      const path = e.path ?? e.param;
      const pathStr = Array.isArray(path) ? path.join(".") : String(path);
      return `${pathStr}: ${e.msg}`;
    }
    if (e?.message || e?.msg) {
      const p = e.path;
      const pathStr = Array.isArray(p) ? p.join(".") : p != null ? String(p) : "";
      const m = e.message || e.msg;
      return pathStr ? `${pathStr}: ${m}` : m;
    }
    try {
      return JSON.stringify(e);
    } catch {
      return String(e);
    }
  };

  if (Array.isArray(data.errors)) {
    data.errors.map(mapItem).filter(Boolean).forEach((x) => parts.push(x));
  } else if (
    data.errors &&
    typeof data.errors === "object" &&
    !Array.isArray(data.errors)
  ) {
    Object.entries(data.errors).forEach(([key, val]) => {
      if (Array.isArray(val)) {
        val.forEach((v) => parts.push(`${key}: ${v}`));
      } else if (val != null) {
        parts.push(`${key}: ${val}`);
      }
    });
  }

  if (Array.isArray(data.details)) {
    data.details.map(mapItem).filter(Boolean).forEach((x) => parts.push(x));
  }

  return parts;
}

export function formatAxiosErrorMessage(error) {
  if (error == null) return "Request failed";
  if (typeof error === "string") return error;

  const res = error.response;
  const status = res?.status;
  const data = res?.data;

  if (typeof data === "string" && data.trim()) return data.trim();

  let errTop = data?.error;
  if (Array.isArray(errTop)) {
    errTop = errTop.filter(Boolean).join("; ");
  } else if (errTop != null && typeof errTop === "object") {
    errTop = errTop.message || JSON.stringify(errTop);
  } else if (errTop != null) {
    errTop = String(errTop);
  } else {
    errTop = "";
  }

  let message =
    (data && (data.message || data.msg || errTop)) || error.message || "";

  const fragments = formatValidationFragments(data);
  if (fragments.length) {
    message = message
      ? `${message} — ${fragments.join("; ")}`
      : fragments.join("; ");
  }

  if (!message) {
    if (status === 401) message = "Unauthorized";
    else if (status === 403) message = "Forbidden";
    else if (status === 422) message = "Validation failed";
    else if (status) message = `Request failed (${status})`;
    else message = "Request failed";
  }

  return message;
}
